// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gd-3";
export var downloadButton = "_gd-4";
export var fileContainer = "_gd-9 _gd-7";
export var fileContainerBase = "_gd-7";
export var fileContainerBaseSm = "_gd-a _gd-7";
export var fileContainerFixedHeight = "_gd-8 _gd-7";
export var fileContainerFixedHeightSm = "_gd-c _gd-a _gd-7";
export var fileContainerSm = "_gd-b _gd-a _gd-7";
export var fileInfo = "_gd-5";
export var fileInfoWidthRestricted = "_gd-6";
export var fileType = "_gd-1";
export var fileTypeName = "_gd-2";
export var fileTypeSm = "_gd-d _gd-1";
export var image = "_gd-0";
export var link = "_gd-f";
export var overflowEllipsis = "_gd-e";